<div class="modal-container-custom">
  <div class="modal-content-custom rejectStyle_1">
    <div class="modal-header">
      <button type="button" class="close" aria-label="Close" id="reject-documents-close" (click)="activeModal.close()">
        <span aria-hidden="true">&times;</span>
      </button>
      <div class="row d-flex align-items-center">
        <div class="col-md-3">
        </div>
        <div class="col-md-6">
          <div>
            <h4 class="modal-title enabled-text">Rejecting Documents</h4>
          </div>
        </div>
        <div class="col-md-3">
        </div>
      </div>
    </div>
    <form autocomplete="off" [formGroup]="rejectionForm">
      <div class="modal-body p-0">
        <div class="dark-bg-info-card m-0 rejectStyle_2">
          <div class="row">
            <div class="col-md-12">
              <div>
                <label class="m-0">
                  Enter the reason for the rejection: <span class="text-danger">*</span>
                </label>
                <div class="r-value-textarea">
                  <textarea id="reject-documents-comments" formControlName="comments"
                    class="form-control rejectStyle_3"></textarea>
                </div>
              </div>
              <div class="mt-4" *ngIf="userRole !== 'investor'">
                <label class="m-0">
                  Select the documents to reject: <span class="text-danger">*</span>
                </label>
                <div formArrayName="rejected_documents"
                  *ngFor="let rejectedDoc of rejectionForm.get('rejected_documents')['controls']; let i = index;">
                  <label class="d-flex align-items-center p-3 mb-2 dark-section cursor-pointer" [formGroupName]="i"
                    for="is-rejected-{{rejectedDoc.value.id}}">
                    <input id="is-rejected-{{rejectedDoc.value.id}}" formControlName="isRejected" type="checkbox" />
                    <div class="ml-4">{{ rejectedDoc.value.name }}</div>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
    <div class="modal-footer modal-footer-custom">
      <button type="button" id="reject-documents-cancel"
        class="col-md-4 btn btn-outline-normal btn-style-right-1 text-left"
        (click)="activeModal.close()">Cancel</button>
      <button id="reject-documents-submit" type="submit"
        class="col-md-4 btn btn-md btn-style-right-1 btn-success text-left for-icon-right for-right-arrow"
        (click)="onRejectClick(rejectionForm.value)">{{ userRole === 'issuer' ? 'Go Back' : 'Reject' }}</button>
    </div>
  </div>
</div>
